import { IMAGE_PATHS } from '@/constants';
import { NoDataFoundProps } from '@/constants/Interfaces/CommonInterfaces';
import React, { memo } from 'react';

const NoDataFound: React.FC<NoDataFoundProps> = ({
  logo = IMAGE_PATHS.skateboardingImg || '',
  text = 'No data found',
  description = 'Try adjusting your search criteria or add new data',
  className = '',
  colSpan = 1,
  showInTable = false
}) => {
  const content = (
    <div className={`flex flex-col items-center gap-2 ${className}`}>
      <div className='text-4xl text-gray-300'>
        {typeof logo === 'string' ? (
          <img width={200} height={200} src={logo} alt='msg-logo' />
        ) : (
          logo
        )}
      </div>
      <p className='text-lg font-medium text-gray-500'>{text}</p>
      {description && (
        <p className='text-sm text-gray-400 text-center max-w-md'>
          {description}
        </p>
      )}
    </div>
  );

  if (showInTable) {
    return (
      <tr>
        <td
          colSpan={colSpan}
          className='px-4 py-8 text-center'
          role='status'
          aria-live='polite'
        >
          {content}
        </td>
      </tr>
    );
  }

  return (
    <div className='px-4 py-8 text-center' role='status' aria-live='polite'>
      {content}
    </div>
  );
};

export default memo(NoDataFound);
